<template>
    <div class="notificationBarTop" v-show="showLoginSlidedown" style="display: none" :aria-hidden="!showLoginSlidedown" role="alert">
        <a :href="loginUrl">Log in to store your form.</a>
        <button type="button" class="close icon icon-close" @click.prevent="showLoginSlidedown = false"><span class="sr-only">Close</span></button>
    </div>
</template>
<script lang="ts">
import { defineComponent, ref, inject } from "vue";
import { useMainStore } from "@/mainStore";
import { getLoginUrlInjectKey } from "@/AppShell.3.vue.InjectKeys";
import { computedAsync } from "@vueuse/core";
export default defineComponent({
    setup() {
        const mainStore = useMainStore();
        const getLoginUrl = inject(getLoginUrlInjectKey)!;
        const showLoginSlidedown = ref(false);
        const loginUrl = computedAsync(() => {
            return getLoginUrl();
        });

        mainStore.isLoggedInPromise.then(async isLoggedIn => {
            showLoginSlidedown.value = !isLoggedIn && !(await mainStore.isFeatureFlagActiveAsync("DisableUserLogin"));
        });

        return {
            loginUrl,
            showLoginSlidedown,
        };
    },
});
</script>
